function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42,10h-8c-0.553,0-1-0.448-1-1V3c0-0.552,0.447-1,1-1h8c0.404,0,0.77,0.244,0.924,0.617c0.155,0.374,0.069,0.804-0.217,1.09L40.414,6l2.293,2.293c0.286,0.286,0.372,0.716,0.217,1.09C42.77,9.756,42.404,10,42,10z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M34 9L34 16"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 13c-3.033 0-5.5-2.467-5.5-5.5S15.467 2 18.5 2 24 4.467 24 7.5 21.533 13 18.5 13zM35 15H14c-3.314 0-6 2.686-6 6v10.889c0 .996.679 1.921 1.662 2.083C10.914 34.178 12 33.215 12 32v-9.529c0-.271.229-.5.5-.5s.5.229.5.5v22.967C13 46.791 14.048 48 15.401 48 16.883 47.999 18 46.839 18 45.3V32.458c0-.276.224-.5.5-.5s.5.224.5.5v13.134c.003.004.007.008.01.012C19.066 46.935 20.155 48 21.5 48c1.381 0 2.5-1.119 2.5-2.5 0-.042-.01-.08-.012-.121C23.99 45.351 24 45.329 24 45.3V21c0-1.105.895-2 2-2h8.889c.996 0 1.921-.679 2.083-1.662C37.178 16.086 36.215 15 35 15z"
});

function SvgPersonWithFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWithFlag);
export default __webpack_public_path__ + "static/media/person-with-flag.b70c3e48.svg";
export { ForwardRef as ReactComponent };